import index from './table.vue';

export default index;
